import { Button, FormInstance, notification, Tooltip, Modal } from 'antd'
import { FaSave } from 'react-icons/fa'
import { IoHome } from 'react-icons/io5'
import React, { useState } from 'react'

import './styles.scss'
import { applicationsStateActions } from '@/state/actions'
import { ApplicationsState, FormState } from '@/state'
import { useComputed } from '@preact/signals-react'
import { EApplicationStatus, EFormEntityType } from '@/interfaces'
import { OfflineState } from '@/state/offline-management'
import applicationRequests from '@/state/applications/requests'


const statusCanEdit = [
  EApplicationStatus.CHANGES_REQUIRED,
  EApplicationStatus.IN_PROCESS,
  EApplicationStatus.WITHOUT_START,
  EApplicationStatus.COMPLETED,
]

export default function FormActions({ form }: { form: FormInstance }) {
  const [modalVisible, setModalVisible] = useState(false)

  const handleSaveForm = async () => {
    FormState.hasRequiredFieldsEmpty.value = false

    ApplicationsState.loading.value = {
      ...ApplicationsState.loading.peek(),
      saving: true,
    }

    await form
      .validateFields()
      .then(async (formValues) => {
        // Buscar arrays de miembros del núcleo familiar en formValues
        let cedulas: string[] = []
        for (const key in formValues) {
          const value = formValues[key]
          if (Array.isArray(value)) {
            value.forEach((item) => {
              if (item && typeof item === 'object') {
                let cedula =
                  item.cedula ||
                  item.Cedula ||
                  item.CEDULA ||
                  item.documento ||
                  item.Documento ||
                  item.DOCUMENTO
                if (!cedula) {
                  // Buscar dinámicamente el primer campo que parezca una cédula
                  for (const k of Object.keys(item)) {
                    if (
                      k.toLowerCase().includes('cedula') ||
                      k.toLowerCase().includes('documento')
                    ) {
                      cedula = item[k]
                      break
                    }
                  }
                }
                if (cedula) cedulas.push(cedula)
              }
            })
          }
        }
        // Validar con RPA si hay cédulas
        if (cedulas.length > 0) {
          const { consultarRPA } = await import('@/services/rpaService')
          const rpaResult = await consultarRPA(cedulas)
          if (rpaResult && rpaResult.inhabilitado) {
            handleDeleteApplication()
            ApplicationsState.loading.value = {
              ...ApplicationsState.loading.peek(),
              saving: false,
            }
            return // Bloquea el guardado
          }
        }
        await applicationsStateActions.processApplication(formValues)
        // notification is handled inside processApplication
      })
      .catch(() => {
        notification.warning({
          message: 'Revisar el formulario',
          description:
            'Algunos campos obligatorios no se encuentran diligenciados',
          placement: 'top',
        })
        FormState.hasRequiredFieldsEmpty.value = true
      })
      .finally(() => {
        ApplicationsState.loading.value = {
          ...ApplicationsState.loading.peek(),
          saving: false,
        }
      })
  }

  function handleDeleteApplication() {
    const applicationId = ApplicationsState.currentApplication.value?.id
    console.debug('[DEBUG][deleteApplication] Modal abierto, id:', applicationId)
    Modal.confirm({
      title: 'Ciudadano con propiedad registrada',
      content: (
        <div>
          El ciudadano consultado tiene propiedades registradas en
          aplicaciones externas y no puede continuar con el proceso.
        </div>
      ),
      okText: 'Aceptar',
      maskClosable: false,
      closable: false,
      centered: true,
      cancelButtonProps: { style: { display: 'none' } },
      onOk: () => {
        console.debug('[DEBUG][deleteApplication] onOk ejecutado, id:', applicationId)
        if (applicationId) {
          return applicationsStateActions.deleteApplication(String(applicationId))
            .then(() => {
              console.debug('[DEBUG][deleteApplication] Eliminación completada')
              window.location.href = '/'
            })
            .catch((error) => {
              console.error('[ERROR][deleteApplication] Falló la eliminación:', error)
              window.location.href = '/'
            })
        }
        window.location.href = '/'
        return Promise.resolve()
      },
    })
  }

  const canShowBackAction = useComputed(
    () =>
      !(
        ApplicationsState.loading.value.savingRow ||
        ApplicationsState.loading.value.saving
      )
  )
  const canShowSaveAction = useComputed(
    () =>
      FormState.currentEntity.value?.type === EFormEntityType.SIMPLE &&
      ApplicationsState.viewMode.value.edit &&
      !OfflineState.isSynchronizing.value &&
      FormState.currentEntity.value.permission?.edit &&
      statusCanEdit.includes(
        ApplicationsState.currentApplication.value
          ?.estadoName as EApplicationStatus
      )
  )

  return (
    <div className='form-actions'>
      {canShowBackAction.value && (
        <Tooltip title='Regresar a la lista de solicitudes' placement='bottom'>
          <Button
            className='action-btn'
            shape='circle'
            icon={<IoHome />}
            onClick={applicationsStateActions.goToHome}
          />
        </Tooltip>
      )}
      {canShowSaveAction.value && (
        <Tooltip title='Guardar' placement='bottom'>
          <Button
            className='action-btn'
            shape='circle'
            icon={<FaSave />}
            onClick={handleSaveForm}
            loading={ApplicationsState.loading.value.saving}
          />
        </Tooltip>
      )}
      <Modal
        title='Resultado de importación masiva RPA'
        visible={modalVisible}
        onOk={() => setModalVisible(false)}
        onCancel={() => setModalVisible(false)}
        centered
      >
        <pre>{/* {modalContent} */}</pre>
      </Modal>
    </div>
  )
}
